<div>
    <p class="title">Are you sure to clear player app data for these devices?</p>
    <div class="content">{{ _monitorDeviceNames }}</div>
</div>